import { getAdExamplesSSR } from "@/ssr/ad-examples"
import {
	SSRTemporaryRedirect,
	wrapSSRAuth,
} from "@/utils/ssr-auth"
import { AdExamplesSingle } from "models/wizard"
import GalleryAll from "sections/gallery/all-gallery"

export type MetaLinks = {
	current: string | null
	next: string | null
	prev: string | null
}

export interface AdExamplesHome {
	type: "home"
	content: AdExamplesHomeSingle[]
}

export interface AdExamplesSearched {
	type: "searched"
	content: AdExamplesSingle[]
	total: number | null
}

export type AdExamplesType =
	| AdExamplesHome
	| AdExamplesSearched

export interface AdExamplesHomeSingle {
	title: string
	query: string
	results: AdExamplesSingle[]
}

export type ApplyFiltersAdExamples = Omit<
	FilterStateAdExamples,
	"applyFilters"
>

export type AspectAdExamples =
	| "1:1"
	| "9:16"
	| "16:9"
	| "4:5"
	| "5:4"
	| null

export type FilterStateAdExamples = {
	searchQuery: string | null
	aspect: AspectAdExamples
	applyFilters: ApplyFiltersAdExamples
}

const indexFiltersWithoutApplied = {
	searchQuery: null,
	aspect: null,
} as const

export const indexFiltersAdExamples: FilterStateAdExamples =
	{
		...indexFiltersWithoutApplied,
		applyFilters: indexFiltersWithoutApplied,
	}

export type AdExamplesPageProps = {
	jobs: AdExamplesType
	initial: FilterStateAdExamples
	pageTitle: string | null
	metaLinks: MetaLinks
	pageNumber: number
}

export default function Templates(
	props: AdExamplesPageProps,
) {
	return (
		<GalleryAll
			adExamplesJobs={props.jobs}
			initialFiltersAdExamples={props.initial}
			pageTitle={props.pageTitle}
			metaLinks={props.metaLinks}
			pageNumber={props.pageNumber}
			initialPage="ad-examples"
		/>
	)
}

export const getServerSideProps = wrapSSRAuth(
	async (context, userInfo) => {
		if (userInfo) {
			throw new SSRTemporaryRedirect(
				"/discover?filter=ad-examples",
			)
		}

		let page = Number(context.query.page)

		if (isNaN(page) || page < 1) {
			page = 1
		}

		const prevNumber = page > 1 ? page - 1 : null

		const metaLinks: MetaLinks = {
			current: "/ad-examples?page=" + page,
			next: "/ad-examples?page=" + (page + 1),
			prev: prevNumber
				? "/ad-examples?page=" + prevNumber
				: null,
		}

		const [jobs] = await Promise.all([
			getAdExamplesSSR(indexFiltersAdExamples, page),
		])

		const props: AdExamplesPageProps = {
			jobs,
			initial: indexFiltersAdExamples,
			pageTitle: null,
			metaLinks,
			pageNumber: page,
		}

		return props
	},
	[],
)
